import React, { useState, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { customTableStyles } from '../../../../utils';
import { CONTENT_TYPE, DATE_FORMAT_DISPLAY, LISTING_LIMIT } from '../../../../constants';
import Loading from '../../../../components/Loading';
import { FormattedMessage, useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import FormattedCurrency from '../../../../components/FormattedCurrency';
import { StatusTag } from '../../../../components/Reuseable/Tag';
import { FaEye } from 'react-icons/fa6';
import { DateTime } from 'luxon';
import { AiOutlineMessage } from 'react-icons/ai';
import { set_chat_to_load } from '../../../../redux/slices/chatsSlice';
import { useDispatch } from 'react-redux';

const CampaignsTable = React.memo(({ influencerId, data, count, loading, currentPage, onPageChange }) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const columns = [
    {
          name: <FormattedMessage id="campaign" defaultMessage="Campaign" />,
          cell: row => (
            <div className="flex py-4 flex-col">
              <span
                className="font-semibold hover:underline cursor-pointer"
                onClick={() => navigate(`/campaign/${row.id}`)}
              >
                {row.project_name}
              </span>
              {/* <span className="text-xs text-gray-500">
                ID: {row.id}
              </span> */}
            </div>
          ),
        },
     {
          name: <FormattedMessage id="start_date" defaultMessage="Start Date" />,
          cell: row => <span>{row.status?.latest_start_date ? DateTime.fromISO(row?.status?.latest_start_date).toFormat(DATE_FORMAT_DISPLAY) : '-'}</span>,
          width: "200px"
        },
        {
          name: <FormattedMessage id="end_date" defaultMessage="End Date" />,
          cell: row => <span>{row?.status?.latest_stop_date && row?.status?.status !== "start" ? DateTime.fromISO(row?.status?.latest_stop_date).toFormat(DATE_FORMAT_DISPLAY) : '-'}</span>,
          width: "200px"
        },
        {
          name: <div className='py-4'><FormattedMessage id="status" defaultMessage="Status" /></div>,
          cell: row => row?.status?.status ? <StatusTag status={row.status.status} /> : '-',
          width: "120px",
        },
    {
          name: "",
          cell: row => (
            <button
              onClick={() => {
                if (row.session_id) {
                  dispatch(set_chat_to_load(row.session_id));
                  navigate(`/campaign/${row.id}/chats`);
                }
              }}
              className={`${row.session_id ? "" : "hidden"} bg-primary rounded-lg p-2 text-white w-fit mx-auto`}
              data-tooltip-id="view-tooltip"
              data-tooltip-content={intl.formatMessage({
                id: "chat",
                defaultMessage: "Chat"
              })}
            >
              <AiOutlineMessage className='text-2xl' />
            </button>
          ),
          width: "70px"
        }

  ];

  return (
    <div className="px-8 py-4 rounded bg-gray-100">
      <h4 className="font-semibold mb-2">
        <FormattedMessage id="campaigns" defaultMessage="Campaigns" />
      </h4>
      {loading ? (
        <Loading />
      ) : (
        <div className='shadow-md rounded-md'>
          <DataTable
            columns={columns}
            data={data}
            customStyles={customTableStyles}
            progressPending={loading}
            pagination
            paginationServer
            paginationTotalRows={count}
            paginationPerPage={LISTING_LIMIT}
            paginationDefaultPage={currentPage}
            paginationComponentOptions={{ noRowsPerPage: true }}
            onChangePage={onPageChange}
            noDataComponent={
              <span className="py-4">
                <FormattedMessage id="no_campaigns_found" defaultMessage="No campaigns found" />
              </span>
            }
            dense
          />
        </div>
      )}
    </div>
  );
});

export default CampaignsTable;